import React, { useCallback } from "react";

import { useAuthContext } from "../../../auth";
import { useDataLayer } from "../../../hooks/use-data-layer";
import { useHeaderMenu } from "../../../hooks/use-header-menu";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";
import { Icon } from "../../icon";

export function LogoutButton() {
  const { labels } = useHeaderMenu();
  const { logout } = useAuthContext();

  const { pushEvent } = useDataLayer();
  const handleOnClick = useCallback(() => {
    pushEvent({
      event: GoogleAnalyticsEvent.Logout,
    });
    logout();
  }, [logout, pushEvent]);

  return (
    <button type="button" className="flex gap-2 items-center text-primary" onClick={handleOnClick}>
      <Icon icon="logout" className="w-5" />
      {labels["header-menu-personal-area-logout-cta"]}
    </button>
  );
}
